// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ae374ad5","952":"74ebda9b"}[chunkId] + ".chunk.js";
};